import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren, TemplateRef, ViewChild } from '@angular/core';
import { OfferPriceDataService } from '../../../core/services/offer-price-data.service';
import {TranslateService} from '@ngx-translate/core';
import {AlertService} from '../../../core/services/alert.service';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap';

@Component({
    selector: 'app-update-price-dialog',
    templateUrl: './update-price-dialog.component.html',
    styleUrls: ['./update-price-dialog.component.css']
})
export class UpdatePriceDialogComponent implements OnInit, AfterViewInit {
    modalRef: BsModalRef;
    @ViewChildren('input') vc;
    @ViewChild('confirmation') confirmationTmplt: TemplateRef<any>;

    constructor(
        private modalService: BsModalService, 
        private translate: TranslateService, 
        private alertService: AlertService,
        private programPriceService: OfferPriceDataService
    ) {
        this.confirmAcceptButton = this.translate.instant('default-text.yes');
        this.confirmCancelButton = this.translate.instant('default-text.no');
        programPriceService.getProgramPrice().subscribe( priceResponse => {
                if (priceResponse && priceResponse['data'] != null) {
                    this.currentPrice = priceResponse['data'].parameter_value;
                }           
         });
     }

    @Output() buttonEvent = new EventEmitter<string>();

    confirmAcceptButton;
    confirmCancelButton;
    updatedPrice: string = null;
    currentPrice: string = null;

    ngOnInit() {
    }

    ngAfterViewInit() {
        setTimeout(() => { this.vc.first.nativeElement.focus() });
    }

    handlePriceInput(event) {
        this.updatedPrice = event.target.value;
    }

    updateClicked() {
        if (this.updatedPrice) {
            const config: ModalOptions = new ModalOptions();
            this.modalRef = this.modalService.show(this.confirmationTmplt, config);
        }
    }

    confirm(){
        this.modalRef.hide();
        this.programPriceService.setProgramPrice(this.updatedPrice).subscribe((response) => {
            this.alertService.success(
                this.translate.instant('shared.update-program_price-dialog.price-update-success')
            );
        }, (error) => {
            if(error.error && error.error.code === 403 && error.error.message_key === "insufficient_user_permission"){
                this.alertService.error(
                    this.translate.instant('shared.error-handling.permission-denied')
                );
            }
            else{
                this.alertService.error(
                    this.translate.instant('shared.error-handling.update-failed')
                );
            }
        });
        this.buttonEvent.emit("Update");
    }

    cancelClicked() {
        this.buttonEvent.emit("Cancel");
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/update-price-dialog/update-price-dialog.component.ts